module.exports = __webpack_public_path__ + "img/logo-cotizacion.8f377f40.png";